module.exports = __webpack_public_path__ + "img/blue-circle-accents.fd46d993.png";